import React, {useEffect, useState} from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { SERVER_URL } from '../constants';
import { Stack } from '@mui/material';
import TextField from '@mui/material/TextField';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import CommonSnackbar from './CommonSnackbar';
import CircularProgress from '@mui/material/CircularProgress';
import { formatTime } from '../helpers/Helpers';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

function OfficeTodaysFixedScheduleAddName (props) {

    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (open || props.openAddCustomerModal) {
            handleOpen();
        }
    }, [open, props.openAddCustomerModal]); // runs whenever open state changes

    const handleOpen = () => {
        setName("");
        setOpen(true);
        props.setOpenCustomerModal(true);
    };

    const [errorTitle, setErrorTitle] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const snackbar = {
        errorTitle,
        errorMessage,
        setErrorTitle,
        setErrorMessage
    }

    const handleClickOpen = () => {
        setOpen(true);
        setName("");
        setSaving(false);
    };

    const handleClose = (event, reason) => {
        if (reason === "backdropClick") return; // ignore backdrop clicks
        setOpen(false);
        setName("");
        setSaving(false);
        props.setOpenCustomerModal(false);
    };

    const[saving, setSaving] = useState(false);

    const[name, setName] = useState("");

    // const[appLink, setAppLink] = useState("");

    const handleChange = (event) => {
        const inputValue = event.target.value;
        const lettersOnly = inputValue.replace(/[^a-zA-Z\s]/g, ''); // allows letters and spaces
        setName(lettersOnly);
    }

    const handleSave = () => {
        createCustomer();
        setSaving(true);
    }

    const handleKeyPress = (e) => {
        if (e.keyCode === 13) {
            // e.preventDefault();
            // handleSave();
        }
    }

    const createCustomer = () => {
        // console.log("createCustomer " + name);
        // console.log("date", props.rawDate);
        fetchAppLink();
    }

    const fetchAppLink = () => {
        const requestData = {
            "office_id": props.officeId,
        };
        // console.log("fetchAppLink", requestData);
        // return;
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/mod/get-fixed-schedule-code', {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            },
            body: JSON.stringify(requestData)
        })
        .then(response => response.json())
        .then(data => {
            // console.log("data", data);
            // console.log("data.data.link", data.data.link);
            // setAppLink(data.data.link.split('/').pop());
            loginGuest(data.data.link.split('/').pop());
        })
        .catch(err => console.error(err));
    }

    const loginGuest = (appLink) => {
        const requestData = {
            "full_name": name,
            "appointment_code": appLink
        };
        // console.log("requestData", requestData);
        // return;
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/mod/login-guest', {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            },
            body: JSON.stringify(requestData)
        })
        .then(response => response.json())
        .then(data => {
            if (data.status == 1)
            {
                console.log("data.data", data.data)
                confirmAppointment(appLink, data.data.id);
            }  
            else {
                setErrorTitle("Error");
                setErrorMessage(data.message);
                return false;
            }
        })
        .catch(err => console.error(err))
    }

    const confirmAppointment = (appLink, userId) => {
        console.log("confirmAppointment userId", userId);
        const requestData = {
            "time_slot_id": props.timeSlotId,
            "confirmation_code": appLink,
            "user_id": userId
        };
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/mod/confirm-fixed-schedule', {
            method: 'POST',
            headers: { 
                'Content-Type':'application/json',
                'Accept':'application/json',
                'Authorization' : 'Bearer ' + token
            },
            body: JSON.stringify(requestData)
        })
        .then(response => response.json())
        .then(data => {
            if (props.fetchTimeSlotList) {
                props.fetchTimeSlotList();
                handleClose();
            }
        })
        .catch(err => console.error(err))
    }

    return(
        <React.Fragment>
            <CommonSnackbar snackbar={snackbar} />
            <BootstrapDialog
                sx={{
                    "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "500px",  // Set your width here
                    },
                    },
                }}
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open || props.openAddCustomerModal}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="flex-start"
                    spacing={0}
                    >
                        <Typography sx={{ lineHeight: 1.2 }} variant="h6">
                        Add Client/Customer
                        </Typography>
                        <Typography sx={{ lineHeight: 1.2 }} variant="body1">
                            time: {formatTime(props.time)}
                        </Typography>
                    </Stack>
                </DialogTitle>
                <DialogContent dividers={true} sx={{ m: 0, p: 0 }} >
                    <Stack spacing={2} padding={0}>
                        <Typography sx={{ lineHeight: 1.2 }} variant="body2">
                            <b>Warning:</b> Only input a name manually as a last resort. Customers should normally enter their name themselves by scanning your QR code. 
                        </Typography>

                        <TextField
                            sx={{ width: 1 }}
                            name='name'
                            value={name}
                            id="outlined-multiline-static"
                            label="Name"
                            inputProps={{ maxLength: 30 }}
                            onChange={handleChange}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onKeyDown={handleKeyPress}
                        />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} >Cancel</Button>
                     { saving ? <CircularProgress size="1rem" /> : <Button disabled={!name.trim()} onClick={handleSave} >Save</Button> } 
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    );
}

export default OfficeTodaysFixedScheduleAddName;